export enum PurchaseInvoiceTabsEnum {
  GENERAL = 'general',
  TEAM_PROJECTS = 'projectsAndTeams',
  ESTIMATE_ITEM_POSITIONS = 'estimateItemInvoiceTabTitle',
  NOTES = 'notes',
}
